import React from "react";

export interface DonutTooltipEntry {
  name: string;
  value: number;
}

interface DonutTooltipContentProps {
  active?: boolean;
  payload?: Array<{ payload: { name: string; value: number } }>;
  donutData: DonutTooltipEntry[];
  currentColors: string[];
  /** Override the total used for the percent — defaults to the sum of `donutData`. */
  total?: number;
  fontSize?: number;
}

// Shared Recharts <Tooltip content> renderer for every donut widget — text is
// colored and sized to match its legend row (the Direct-tab standard), percent
// is derived from donutData (or an override total) so it works for any
// segment count/order.
const DonutTooltipContent: React.FC<DonutTooltipContentProps> = ({ active, payload, donutData, currentColors, total: totalOverride, fontSize = 14 }) => {
  if (!active || !payload?.length) return null;
  const { name, value } = payload[0].payload;
  const total = totalOverride ?? donutData.reduce((sum, item) => sum + item.value, 0);
  const percent = total > 0 ? Number(((value / total) * 100).toFixed(1)) : 0;
  const colorIndex = donutData.findIndex(item => item.name === name);
  const color = colorIndex >= 0 ? currentColors[colorIndex % currentColors.length] : undefined;
  return (
    <div className="bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600 p-2 rounded-lg">
      <span style={{ color, fontSize }}>{`${name}: ${value} (${percent}%)`}</span>
    </div>
  );
};

export default DonutTooltipContent;
